var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-list-cell',{attrs:{"type":"date","format":_vm.format,"condensed":_vm.condensed}},[_c('core-date',{attrs:{"date":_vm.value,"invalid":"n/a"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }